export enum Type {
  SET_CURRENT_ORGANIZATION_UUID = 'DASHBOARD/SET_CURRENT_ORGANIZATION_UUID',
}

interface Action<T> {
  type: T;
}

export interface SetCurrentOrganizationUUID
  extends Action<Type.SET_CURRENT_ORGANIZATION_UUID> {
  currentOrganizationUUID?: string;
}

export type State = string | null;

export const initialState = null;

export default (
  state: State = initialState,
  action: SetCurrentOrganizationUUID
): string | null => {
  switch (action.type) {
    case Type.SET_CURRENT_ORGANIZATION_UUID:
      return action.currentOrganizationUUID ?? initialState;
    default:
      return state;
  }
};

export const actions = {
  setCurrentOrganizationUUID: (
    currentOrganizationUUID: string
  ): SetCurrentOrganizationUUID => ({
    type: Type.SET_CURRENT_ORGANIZATION_UUID,
    currentOrganizationUUID,
  }),
};
